import PropTypes from 'prop-types';
import React from 'react';
import {Link} from 'react-router';
import StorySummary from 'modules/News/components/StorySummary';

require('./NewsSection.scss');

export default function NewsSection({
  sectionLabel,
  newsItems,
  additionalNewsLinks = [],
  showHeading = true,
  expandedHeading = true,
  showCategory = false,
  sectionLink = null,
  showByline
}) {
  if (newsItems.length > 0) {
    let heading = expandedHeading ? `Latest ${sectionLabel} News` : sectionLabel;
    if (sectionLink && sectionLink.length > 0) {
      heading = <Link to={sectionLink}>{heading}</Link>;
    } 

    return (
      <section className="sport-section">
        { showHeading && <h3 className="section-title">{heading}</h3>}
        <section className="sport-news">
          { newsItems.map(item => <StorySummary key={item.article_reference.id} imageType="sectionArticle" data={item} metaDataFlags={{category: showCategory, showByline: showByline}}/>) }
          <div className="action-links sport-links">
            {additionalNewsLinks.map(link => <Link className="section-button large-primary-button" key={`${link.href}:${link.text}`} to={link.href}>{link.text}</Link>)}
          </div>
        </section>
      </section>
    );
  }
  else {
    return null;
  }
}

NewsSection.propTypes = {
  sectionLabel: PropTypes.string.isRequired,
  sectionLink: PropTypes.string,
  showHeading: PropTypes.bool,
  expandedHeading: PropTypes.bool,
  showCategory: PropTypes.bool,
  showByline: PropTypes.bool,
  newsItems: PropTypes.array,
  additionalNewsLinks: PropTypes.array
};



// WEBPACK FOOTER //
// ./modules/Common/components/NewsSection.js